import React from 'react';
import { Button, Select } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts';
import { isOldBrowserMode } from '../utils/voicePreferences';
import { TvLogoutPanel } from '../components/TvInlinePanel';

const PAGE_OPTIONS = [
  { value: 'dashboard', label: 'Doctor QMS' },
  { value: 'deptdashboard', label: 'Department QMS' },
  { value: 'warddashboard', label: 'Ward Dashboard' },
  { value: 'doctordash', label: 'Doctor Dashboard' },
];

function HomePage() {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const oldBrowser = isOldBrowserMode();
  const [showLogoutPanel, setShowLogoutPanel] = React.useState(false);

  const handleSelect = (pageValue) => {
    navigate(`/${pageValue}`);
  };

  const openLogoutPanel = () => {
    setShowLogoutPanel(true);
  };

  const handleLogoutConfirm = () => {
    setShowLogoutPanel(false);
    logout();
    navigate('/login');
  };

  return (
    <div className="homepage-page">
      <div className="homepage-header-bar">
        <img src={'drhmslogo.png'} alt={'QMS Logo'} className="homepage-logo" />
        <LogoutOutlined
          onClick={openLogoutPanel}
          className="homepage-logout-icon"
          title="Logout"
        />
      </div>

      <TvLogoutPanel
        visible={showLogoutPanel}
        onCancel={() => setShowLogoutPanel(false)}
        onConfirm={handleLogoutConfirm}
      />

      <div className="homepage-card">
        <div className="homepage-header">
          <p>Choose where you want to go</p>
        </div>

        <div className="homepage-options">
          {oldBrowser ? (
            <Select
              placeholder="Select page"
              size="large"
              className="homepage-nav-dropdown"
              options={PAGE_OPTIONS}
              onChange={handleSelect}
            />
          ) : (
            PAGE_OPTIONS.map((page) => (
              <Button
                key={page.value}
                block
                size="large"
                className="homepage-option-btn"
                onClick={() => handleSelect(page.value)}
              >
                {page.label}
              </Button>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default HomePage;